import React, { useEffect, useState, useRef } from "react";
import { sendGetReq, sendPutReq } from "../DAL/http";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";

const Jobs = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("active");
  const [totalRecords, setTotalRecords] = useState(0);
  const [jobs, setJobs] = useState(null);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 5,
    page: 0,
    sortField: null,
    sortOrder: null,
    filters: {
      name: { value: "", matchMode: "contains" },
      // 'country.name': { value: '', matchMode: 'contains' },
      email: { value: "", matchMode: "contains" },
      // 'representative.name': { value: '', matchMode: 'contains' }
    },
  });

  let networkTimeout = null;

  useEffect(() => {
    loadLazyData();
  }, [lazyState]);

  const loadLazyData = () => {
    setLoading(true);

    if (networkTimeout) {
      clearTimeout(networkTimeout);
    }

    //imitate delay of a backend call
    networkTimeout = setTimeout(() => {
      sendGetReq(
        "job-openings/" +
        status +
        "/" +
        [lazyState.page] +
        "/" +
        [lazyState.rows]
      )
        .then((data) => {
          debugger;
          setTotalRecords(data.count);
          setJobs(data.list);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error getting all Users:", error);
        });
      // CustomerService.getCustomers({ lazyEvent: JSON.stringify(lazyState) }).then((data) => {
      // });
    }, Math.random() * 1000 + 250);
  };

  const clickActiveLoadLazyData = () => {
    debugger;
    setStatus("active");
    setLoading(true);

    if (networkTimeout) {
      clearTimeout(networkTimeout);
    }

    //imitate delay of a backend call
    networkTimeout = setTimeout(() => {
      sendGetReq(
        "job-openings/" +
        "active" +
        "/" +
        [lazyState.page] +
        "/" +
        [lazyState.rows]
      )
        .then((data) => {
          debugger;
          setTotalRecords(data.count);
          setJobs(data.list);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error getting all Users:", error);
        });
      // CustomerService.getCustomers({ lazyEvent: JSON.stringify(lazyState) }).then((data) => {
      // });
    }, Math.random() * 1000 + 250);
  };

  const clickInActiveLoadLazyData = () => {
    debugger;
    setStatus("inactive");
    setLoading(true);

    if (networkTimeout) {
      clearTimeout(networkTimeout);
    }

    //imitate delay of a backend call
    networkTimeout = setTimeout(() => {
      sendGetReq(
        "job-openings/" +
        "inactive" +
        "/" +
        [lazyState.page] +
        "/" +
        [lazyState.rows]
      )
        .then((data) => {
          debugger;
          setTotalRecords(data.count);
          setJobs(data.list);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error getting all Users:", error);
        });
      // CustomerService.getCustomers({ lazyEvent: JSON.stringify(lazyState) }).then((data) => {
      // });
    }, Math.random() * 1000 + 250);
  };

  const onPage = (event) => {
    debugger;
    event.page = event.first;
    setlazyState(event);
  };

  const onSort = (event) => {
    setlazyState(event);
  };

  const onFilter = (event) => {
    event["first"] = 0;
    setlazyState(event);
  };

  const imageBodyTemplate = (product) => {
    console.log(product);
    console.log(product.image);
    return (
      <img
        src={`https://services.infolabsinc.com/job-images/${product.image}`}
        alt={product.image}
        className="w-6rem shadow-2 border-round"
      />
    );
  };

  const onViewJobApplications = (rowData) => {
    console.log(rowData);
    navigate("/job-applications/" + rowData._id);
  };

  const navigate = useNavigate();

  const ActionBodyTemplate = (rowData) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleAccept = () => {
      debugger
      let formData = {
        status: status
      }
      if (status === 'active') {
        formData = {
          status: 'inactive'
        }
      } else if (status === 'inactive') {
        formData = {
          status: 'active'
        }
      }
      if (networkTimeout) {
        clearTimeout(networkTimeout);
      }
      //imitate delay of a backend call
      networkTimeout = setTimeout(() => {
        debugger
        sendPutReq("job-openings/" + rowData._id, formData)
          .then((response) => {
            setShow(false);
            if (status === 'active') {
              clickActiveLoadLazyData();
              alert('Job deactivated successfully');
            } else {
              clickActiveLoadLazyData();
              alert('Job activated successfully');
            }


          })
          .catch((error) => {
            console.error("Error saving user:", error);
          });
      });
    }


    const handleReject = () => {
      setShow(false);
      // Handle reject action
      // You can replace this with your toast notification logic
      // alert('You have rejected');
    };

    const showTemplate = () => {
      setShow(true);
    };
    return (
      <div className="actions d-flex">
        {/* <ConfirmDialog group="templating" /> */}

        <Modal show={show} onHide={handleClose} centered>
          <Modal.Dialog style={{ maxWidth: '400px', }}>
            {/* <Modal.Content modal-content> */}
            <Modal.Header closeButton>
              <Modal.Title className="pl-2">Confirmation</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
              <div className="d-flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
                <i className="pi pi-exclamation-circle text-6xl text-primary-500"></i>
                {status === 'active'
                  ?
                  <span>Please confirm to deactivate job.</span>
                  :
                  <span>Please confirm to acivate job.</span>
                }

              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleReject} className="btn btn-secondary">No</Button>
              <Button variant="primary" onClick={handleAccept} className="btn btn-primary">Yes</Button>
            </Modal.Footer>
            {/* </Modal.Content> */}

          </Modal.Dialog>
        </Modal>
        <div className="mr-2">
          <Button
            icon="pi pi-eye"
            className="p-button-rounded p-mr-2 mt-1"
            style={{
              backgroundColor: "#0F172A",
              height: "30px",
              width: "30px",
              borderRadius: "15px",
            }}
            onClick={() => onViewJobApplications(rowData)}
          />
        </div>
        <div>

          {rowData.status === 'active' ? (
            <button
              type="button"
              class="btn btn-warning confirm-btn"
              onClick={() => showTemplate()}
            >
              <div className="d-flex ">
                <i
                  class="fas fa-times icon-check mr-1"
                  style={{ alignSelf: "center" }}
                ></i>{" "}
                Deactivate
              </div>
            </button>
          ) : (
            <button
              type="button"
              class="btn btn-success confirm-btn"
              onClick={() => showTemplate()}
            >
              <div className="d-flex ">
                <i
                  class="fas fa-check icon-check mr-1"
                  style={{ alignSelf: "center" }}
                ></i>{" "}
                Activate
              </div>
            </button>
          )}
        </div>
      </div>
    );
  };
  const toast = useRef(null);

  // const accept = () => {
  //   toast.current.show({
  //     severity: "info",
  //     summary: "Confirmed",
  //     detail: "You have accepted",
  //     life: 3000,
  //   });
  // };

  // const reject = () => {
  //   toast.current.show({
  //     severity: "warn",
  //     summary: "Rejected",
  //     detail: "You have rejected",
  //     life: 3000,
  //   });
  // };

  // const showTemplate = () => {
  //   confirmDialog({
  //     group: "templating",
  //     header: "Confirmation",
  //     message: (
  //       <div
  //         className="d-flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border"
  //         style={{ padding: "20px" }}
  //       >
  //         <i className="pi pi-exclamation-circle text-6xl text-primary-500"></i>
  //         <span>Please confirm to proceed moving forward.</span>
  //       </div>
  //     ),
  //     accept,
  //     reject,
  //   });
  // };

  return (
    <>
      <div className="row">
        <h2 className=" mb-3" style={{ color: "#0F172A", fontSize: "30px" }}>
          All Job Posts
        </h2>
        <div className="shadow">
          <div className="col-md-12">
            {/* <span className="p-buttonset">
                    <Button label="All" icon="pi pi-check" severity="secondary" onClick={loadLazyData} />
                    <Button label="Active" icon="pi pi-times" severity="success" onClick={clickActiveLoadLazyData} />
                    <Button label="Inactive" icon="pi pi-ban" severity="danger" onClick={clickInActiveLoadLazyData} />
                </span> */}

            {/* <button type="button" className="btn btn-success"
                        onClick={loadLazyData}>
                        All
                    </button> */}
            <div className="btn-container mt-2 mb-3 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-primary mr-3"
                onClick={clickActiveLoadLazyData}
              >
                Active
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={clickInActiveLoadLazyData}
              >
                Inactive
              </button>
            </div>
          </div>
          <div className="col-md-12">
            <DataTable
              value={jobs}
              lazy
              filterDisplay="row"
              key="{id}"
              paginator
              showGridlines
              first={lazyState.first}
              rows={10}
              totalRecords={totalRecords}
              onPage={onPage}
              rowsPerPageOptions={[10, 25, 50]}
              onSort={onSort}
              sortField={lazyState.sortField}
              sortOrder={lazyState.sortOrder}
              onFilter={onFilter}
              filters={lazyState.filters}
              loading={loading}
              tableStyle={{ minWidth: "50rem" }}
              className="custom-datatable p-column-header custom-datatable p-datatable-header"
            >
              <Column field="title" header="Title" style={{ width: "400px" }} />
              <Column
                header="Image"
                body={imageBodyTemplate}
                style={{ width: "200px" }}
              />
              <Column
                field="createdDate"
                header="Date"
                body={(rowData) =>
                  new Date(rowData.createdDate).toISOString().substring(0, 10)
                }
                style={{ width: "250px" }}
              />
              <Column
                field="desc"
                header="Message"
                style={{ width: "400px" }}
              />
              {/* <Column field="Message" sortable filter header="Company" filterPlaceholder="Search" /> */}
              <Column body={ActionBodyTemplate} header="Actions" />

              {/* <Column>
                            <Link to={`job-application/${id}`} className="mr-2 btn btn-dark">Job-Applications</Link>
                        </Column> */}
            </DataTable>
          </div>
        </div>
      </div>
    </>
  );
};

export default Jobs;
